import Slider01 from "../assets/img/slider01.webp";
import Slider02 from "../assets/img/slider02.webp";
import Slider03 from "../assets/img/slider03.webp";


export const Images = {
    Slider01,
    Slider02,
    Slider03,

};